import { css } from 'styled-components';
import {
  White, Blue, greyThree, greySeven, primaryOne, Red,
} from '../../../../elements/Colors';

export const filterSelectionStyle = css`
  background-color: ${White};
  border: 1px solid ${Blue};
  box-shadow: 1px 1px 5px ${greyThree};
  padding: 12px;
  position: absolute;
  text-align: left;
  width: 280px;
  z-index: 2; // z-index 1 -> "No Results Found message of React-Table"
  display: flex;
  flex-direction: column;
  font-weight: normal;

  &.text {
    height: 262px;
  }

  &.date,
  .number {
    height: 413px;
  }

  .advanced-filter__title {
    margin-top: 0;
  }

  .advanced-filter__fields {
    margin-bottom: 12px;

    &:last-of-type {
      margin-top: 24px;
    }

    .advanced-filter__date-field {
      border-radius: 0 !important;
      display: block;
      margin-bottom: 6px;
      padding: 3px !important;
      width: 100%;
    }

    .number-input,
    .text-input {
      border-radius: 0 !important;
      display: block;
      margin-bottom: 6px;
      width: 100%;
    }
  }
`;

export const titleStyle = css`
  color: ${primaryOne};
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 18px;
`;

export const commonButtonStyle = css`
  width: 100%;
  min-height: auto;
  border-radius: 24px;
  display: inline-block;
  height: 24px;
  font-size: 14px;
  margin-bottom: 6px;
  padding: 2px 6px 3px 6px;

  &.active,
  &.apply {
    background-color: ${Blue};
    color: ${White};
  }

  &.inactive,
  &.cancel,
  &.disabled,
  &.apply:disabled {
    background-color: ${White};
    border: 1px solid ${greySeven};
    color: ${primaryOne};
  }
`;

export const filterButtonStyle = css`
  ${commonButtonStyle};
`;

const applyButtonStyleNormal = css`
  background-color: ${Blue};
  color: ${White};
`;

const applyButtonStyleDisable = css`
  background-color: ${White};
  border: 1px solid ${greySeven};
  color: ${primaryOne};
`;

export const applyButtonStyle = css`
  ${commonButtonStyle};
  ${(props) => (props.disabled ? applyButtonStyleDisable : applyButtonStyleNormal)};
`;

export const clearButtonStyle = css`
  ${commonButtonStyle};
  background-color: ${Red};
  color: ${White};
`;

export const cancelButtonStyle = css`
  ${commonButtonStyle};
  background-color: ${White};
  border: 1px solid ${greySeven};
  color: ${primaryOne};
`;
